import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './Layout';
import { HomePage } from './HomePage';
import OnboardingPage from './OnboardingPage';
import ShortOnboardingPage from './ShortOnboardingPage';
import { ProfilePage } from './ProfilePage';
import { MyNftsPage } from './MyNftsPage';
import { NFTDetailPage } from './NFTDetailPage';
import { MyDropsPage } from './MyDropsPage';
import { PrizePage } from './PrizePage';
import { ClaimRewardPage } from './ClaimRewardPage';
import { SBPLinkingPage } from './SBPLinkingPage';
import { WhiteListPage } from './WhiteListPage';
import { RoadmapRoutePage } from './RoadMapPage';
import { SettingsPage } from './SettingsPage';
import { FAQPage } from './FAQPage';
import { TransactionHistoryPage } from './TransactionHistoryPage';
import { SupportPage } from './SupportPage';
import { PenkiBalancePage } from './PenkiBalancePage';
import { ShopPage } from './ShopPage';
import { ShopProductPage } from './ShopProductPage';
import { useTelegram } from '../hooks/useTelegram';
import { CatalogFilterProvider } from '../contexts/CatalogFilterContext';

interface AppRouterProps {
  showOnboarding: boolean;
  onOnboardingComplete: () => void;
  showShortOnboarding: boolean;
  onShortOnboardingComplete: () => void;
  onShowFullOnboarding: () => void;
}

export const AppRouter: React.FC<AppRouterProps> = ({ 
  showOnboarding, 
  onOnboardingComplete,
  showShortOnboarding,
  onShortOnboardingComplete,
  onShowFullOnboarding,
}) => {
  const { isReady } = useTelegram();

  // Show loading screen while initializing
  if (!isReady) {
    return (
      <div className="app-loading">
        <div className="loading-content">
          <div className="loading-icon"></div>
          <p>Загрузка...</p>
        </div>
      </div>
    );
  }

  return (
    <>
      {showOnboarding ? (
        <OnboardingPage onComplete={onOnboardingComplete} />
      ) : showShortOnboarding ? (
        <ShortOnboardingPage 
          onComplete={onShortOnboardingComplete} 
          onShowFullOnboarding={onShowFullOnboarding} 
        />
      ) : (
        <Layout>
          <CatalogFilterProvider>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/nft/:id" element={<NFTDetailPage />} />
            <Route path="/my-nfts" element={<MyNftsPage />} />
            <Route path="/my-drops" element={<MyDropsPage />} />
            <Route path="/prizes/:id" element={<PrizePage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/claim-reward" element={<ClaimRewardPage />} />
            <Route path="/sbp-linking" element={<SBPLinkingPage />} />
            <Route path="/white-list" element={<WhiteListPage />} />
            <Route path="/roadmap" element={<RoadmapRoutePage />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/transactions" element={<TransactionHistoryPage />} />
            <Route path="/penki" element={<PenkiBalancePage />} />
            <Route path="/shop" element={<ShopPage />} />
            <Route path="/shop/:id" element={<ShopProductPage />} />
            <Route path="/purchases/:id" element={<ShopProductPage owned />} />
            <Route path="/support" element={<SupportPage />} />
            <Route path="/onboarding" element={<OnboardingPage onComplete={onOnboardingComplete} />} />
            {/* Catch all route - redirect to home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          </CatalogFilterProvider>
        </Layout>
      )}
    </>
  );
};
